export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";

export const STATUS = {
  pending: { label: "Pending", dot: "bg-slate-400", cls: "bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/30" },
  awaiting_signature: { label: "Awaiting Signature", dot: "bg-amber-500", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/40" },
  overdue: { label: "Overdue", dot: "bg-red-500", cls: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/40" },
  ready_to_invoice: { label: "Ready to Invoice", dot: "bg-blue-500", cls: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/40" },
  paid: { label: "Paid", dot: "bg-emerald-500", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/40" },
};

export const PLAN_LABEL = { free: "Free", premium: "Premium", super_premium: "Super Premium" };
